export const INCOMING_CALL_REQUEST_TYPE = "incoming_call_request";

export const CALL_NOTIFICATION_FLOW = {
  INCOMING: "incoming",
  MISSED: "missed",
};

export const normalizePushKey = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const isIncomingCallRequestPush = (data) =>
  normalizePushKey(data?.type) === INCOMING_CALL_REQUEST_TYPE;

export const resolveCallNotificationFlow = (data) =>
  normalizePushKey(data?.callNotificationFlow) ||
  normalizePushKey(data?.callNotificationType);

export const isMissedCallPush = (data) =>
  isIncomingCallRequestPush(data) &&
  resolveCallNotificationFlow(data) === CALL_NOTIFICATION_FLOW.MISSED;

/**
 * Foreground incoming-call pushes are hidden while the recipient has a visible
 * tab on the site/PWA so Matrix can show the in-app UI. Missed-call pushes are
 * always shown. Call only when document.visibilityState is "visible".
 */
export const shouldSuppressVisibleIncomingCallPush = (data) => {
  if (!isIncomingCallRequestPush(data) || isMissedCallPush(data)) {
    return false;
  }

  const flow = resolveCallNotificationFlow(data);
  if (flow && flow !== CALL_NOTIFICATION_FLOW.INCOMING) {
    return false;
  }

  return true;
};
